/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  SettleBatchCompletePathParameters,
  SettleBatchConfirmPathParameters,
  SettleBatchDetailPathParameters,
  SettleBatchListParams,
  SettleBatchPayablesPathParameters,
  SettleBatchVoidParams,
  SettleBatchVoidPathParameters,
  SettlementBatchGenerateDTO,
  SettlementInvoiceDTO,
  SettlementTransferDTO,
  TableDataInfo
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 作废结算批次
 */
const settleBatchVoid = (
    { batchId }: SettleBatchVoidPathParameters,
    params: SettleBatchVoidParams,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/${batchId}/void`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 财务确认结算批次
 */
const settleBatchConfirm = (
    { batchId }: SettleBatchConfirmPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/${batchId}/confirm`, method: 'POST'
    },
      );
    }
  /**
 * @summary 复核归档结算批次
 */
const settleBatchComplete = (
    { batchId }: SettleBatchCompletePathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/${batchId}/complete`, method: 'POST'
    },
      );
    }
  /**
 * @summary 登记对公转账
 */
const settleBatchTransfer = (
    settlementTransferDTO: SettlementTransferDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/transfer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settlementTransferDTO
    },
      );
    }
  /**
 * @summary 生成批次前预览
 */
const settleBatchPreview = (
    settlementBatchGenerateDTO: SettlementBatchGenerateDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settlementBatchGenerateDTO
    },
      );
    }
  /**
 * @summary 手工触发月结批次生成
 */
const settleBatchMonthly = (

 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/monthly`, method: 'POST'
    },
      );
    }
  /**
 * @summary 登记商家发票
 */
const settleBatchInvoice = (
    settlementInvoiceDTO: SettlementInvoiceDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/invoice`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settlementInvoiceDTO
    },
      );
    }
  /**
 * @summary 生成结算批次
 */
const settleBatchGenerate = (
    settlementBatchGenerateDTO: SettlementBatchGenerateDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settlementBatchGenerateDTO
    },
      );
    }
  /**
 * @summary 结算批次详情
 */
const settleBatchDetail = (
    { batchId }: SettleBatchDetailPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/settlement/${batchId}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 批次内应付流水明细
 */
const settleBatchPayables = (
    { batchId }: SettleBatchPayablesPathParameters,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/reward/settlement/${batchId}/payables`, method: 'GET'
    },
      );
    }
  /**
 * @summary 结算批次列表
 */
const settleBatchList = (
    params: SettleBatchListParams,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/reward/settlement/list`, method: 'GET',
        params
    },
      );
    }
  return {settleBatchVoid,settleBatchConfirm,settleBatchComplete,settleBatchTransfer,settleBatchPreview,settleBatchMonthly,settleBatchInvoice,settleBatchGenerate,settleBatchDetail,settleBatchPayables,settleBatchList}};
export type SettleBatchVoidResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchVoid']>>>
export type SettleBatchConfirmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchConfirm']>>>
export type SettleBatchCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchComplete']>>>
export type SettleBatchTransferResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchTransfer']>>>
export type SettleBatchPreviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchPreview']>>>
export type SettleBatchMonthlyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchMonthly']>>>
export type SettleBatchInvoiceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchInvoice']>>>
export type SettleBatchGenerateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchGenerate']>>>
export type SettleBatchDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchDetail']>>>
export type SettleBatchPayablesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchPayables']>>>
export type SettleBatchListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['settleBatchList']>>>
